<script>
import BaseFilter from "./BaseFilter";
import { mapGetters } from "vuex";

export default {
  name: "SportSearch",
  extends: BaseFilter,
  computed: {
    ...mapGetters({
      options: "sports",
    }),
  },
  data() {
    return {
      placeholder: "Alle sporten",
      filtername: "sporten",
      type: "sporten",
    };
  },
};
</script>

